/* LG EXPRESS — Categories
   Reveal cards as they enter viewport with stagger.
*/
(function () {
  'use strict';

  const reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    if (!root || root.dataset.lgCatsInit === '1') return;
    root.dataset.lgCatsInit = '1';

    const cards = root.querySelectorAll('[data-lg-cat-card]');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach((c) => c.setAttribute('data-in', 'true'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = Array.from(cards).indexOf(entry.target);
          entry.target.style.transitionDelay = `${Math.min(idx, 6) * 90}ms`;
          entry.target.setAttribute('data-in', 'true');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    cards.forEach((c) => io.observe(c));
  }

  function boot() {
    document.querySelectorAll('[data-lg-cats]').forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-lg-cats]');
    if (root) reveal(root);
  });
})();
